import { primary, white } from 'hfty-styles/src/colors'
import { flex } from 'hfty-styles/src/mixins'

const SELECTOR_AND_TOTAL = '280px'

export const styles = {
  soilSampleCard: {
    position: 'relative',
    width: '100%',
    marginBottom: '50px',
    paddingBottom: '50px',
    borderBottom: '1px solid rgb(240, 240, 240)',
  },
  cardMain: {
    position: 'relative',
    ...flex('space-between', 'flex-start'),
    width: '100%',
  },
  descriptionListTitle: {
    display: 'block',
    padding: '5px 0',
    fontSize: '18px',
  },
  descriptionList: {
    margin: 0,
    padding: '5px 0 0 30px',
  },
  descriptionListItem: {
    listStyle: 'disc',
  },
  calculator: {
    margin: '0 10px',
    padding: '15px 12px',
    border: `1px solid rgb(197, 197, 197)`,
  },
  calculatorHeader: {
    margin: '5px 0 15px',
    paddingLeft: '10px',
    color: primary(),
    fontSize: '17px',
  },
  calculatorContent: {
    ...flex('space-between', 'flex-end'),
    marginBottom: '15px',
  },
  calculatorField: {
    maxWidth: '58px',
    margin: '0 10px',
    lineHeight: 'normal',
  },
  calculatorFieldTitle: {
    display: 'block',
    paddingBottom: '10px',
    fontSize: '14px',
  },
  calculatorFieldInput: {
    height: '22px',
    maxWidth: '50px',
    paddingLeft: '5px',
    fontSize: '14px',
    border: '1px solid #c5c5c5',
  },
  calculatorSign: {
    padding: '0 0 3px 0',
  },
  calculatorFooter: {
    ...flex('flex-end'),
    width: '100%',
  },
  calculatorFooterTitle: {
    fontSize: '14px',
    fontWeight: 300,
    paddingRight: '9px',
  },
  selectorAndTotal: {
    ...flex('space-between'),
    width: SELECTOR_AND_TOTAL,
  },
  qty: {
    ...flex(),
    height: '155px',
  },
  qtyTitle: {
    paddingRight: '10px',
  },
  qtyWrapper: {
    paddingRight: '5px',
    border: `1px solid rgb(197, 197, 197)`,
  },
  qtySelect: {
    width: '165px',
    height: '37px',
    color: 'rgb(121, 121, 121)',
    backgroundColor: white(),
    fontSize: '14px',
    border: 'none',
    outline: 'none',
  },
  total: {
    ...flex('flex-start'),
    height: '155px',
  },
  totalText: {
    fontSize: '17px',
    color: primary(),
  },
  bottomTitle: {
    marginTop: '25px',
    fontSize: '14px',
  },
}

export const selectStyles = {
  selectWrapper: {
    fontSize: '14px',
    marginRight: 0,
  },
  select: {
    width: '57px',
    height: '24px',
    borderRadius: 0,
  },
  arrowWrapper: {
    height: '13px',
  },
}
